var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPrayerList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-7530.44,-421.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "write-black",
    transform: "matrix(0.145417,0,0,0.186342,7126.92,362.634)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2774.96,
    y: 316.846,
    width: 220.057,
    height: 171.727,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.87679,0,0,5.36648,-49010.3,-1946.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7547.21,427.01L7537.74,427.01C7535.55,427.01 7533.78,428.787 7533.78,430.976L7533.78,446.376C7533.78,448.565 7535.55,450.343 7537.74,450.343C7537.74,450.343 7553.14,450.343 7553.14,450.343C7555.33,450.343 7557.11,448.565 7557.11,446.376L7557.11,436.911C7557.11,436.543 7556.81,436.245 7556.44,436.245C7556.07,436.245 7555.78,436.543 7555.78,436.911L7555.78,446.376C7555.78,447.83 7554.6,449.01 7553.14,449.01L7537.74,449.01C7536.29,449.01 7535.11,447.83 7535.11,446.376C7535.11,446.376 7535.11,430.976 7535.11,430.976C7535.11,429.523 7536.29,428.343 7537.74,428.343L7547.21,428.343C7547.57,428.343 7547.87,428.044 7547.87,427.676C7547.87,427.308 7547.57,427.01 7547.21,427.01ZM7553.65,425.946L7542.32,437.277C7542.23,437.363 7542.17,437.47 7542.14,437.587L7540.95,442.358C7540.89,442.585 7540.96,442.825 7541.13,442.991C7541.29,443.157 7541.53,443.223 7541.76,443.166L7546.53,441.974C7546.65,441.944 7546.76,441.884 7546.84,441.798L7558.17,430.467C7558.77,429.868 7559.11,429.054 7559.11,428.206C7559.11,426.453 7557.66,425.01 7555.91,425.01C7555.06,425.01 7554.25,425.347 7553.65,425.946ZM7554.59,426.889C7554.94,426.539 7555.42,426.343 7555.91,426.343C7556.93,426.343 7557.78,427.184 7557.78,428.206C7557.78,428.701 7557.58,429.175 7557.23,429.524C7557.23,429.524 7546.03,440.725 7546.03,440.725C7546.03,440.725 7542.51,441.603 7542.51,441.603C7542.51,441.603 7543.39,438.089 7543.39,438.089C7543.39,438.089 7554.59,426.889 7554.59,426.889Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPrayerList);
export default __webpack_public_path__ + "static/media/my_prayer_list.f94b5d405c111387257608c732d20d82.svg";
export { ForwardRef as ReactComponent };